import { render, staticRenderFns } from "./tjlxBarChart.vue?vue&type=template&id=5434d3d7&scoped=true"
import script from "./tjlxBarChart.vue?vue&type=script&lang=js"
export * from "./tjlxBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5434d3d7",
  null
  
)

export default component.exports